(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8411],{

/***/ 21524:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notice-of-privacy-practices",
      function () {
        return __webpack_require__(53187);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44926);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95832);
/* harmony import */ var _components_v5_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32122);
/* harmony import */ var _constants_practiceIds__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34557);







// @ts-expect-error TS7031: Binding element 'privacyNotice' implicitly has an 'any' type.
const Privacy = (param)=>{
    let { privacyNotice  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_v5_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        pageTitle: i18n.t("Notice of Privacy Practices | Carbon Health"),
        pageDescription: i18n.t("Notice of Carbon Health's Privacy Practices"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    dangerouslySetInnerHTML: {
                        __html: "\n              .hipaa h1,\n              .hipaa h2,\n              .hipaa h3,\n              .hipaa h4,\n              .hipaa p {\n                font-weight: 500;\n                margin-bottom: 1rem;\n              }\n\n              .hipaa ul {\n                list-style: disc;\n                margin: 0 1rem 1rem;\n              }\n\n              .hipaa li {\n                margin: .5rem 1rem;\n                line-height: 1.4;\n              }\n\n              .hipaa a {\n                color: #158562;\n                text-decoration: underline;\n              }\n            "
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hipaa pt20 ph8",
                style: {
                    maxWidth: 1200,
                    margin: "20px auto 40px",
                    lineHeight: 1.4
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: privacyNotice
                    }
                })
            })
        ]
    });
};
Privacy.getInitialProps = async ()=>{
    const { privacyNotice  } = await (0,_services_api__WEBPACK_IMPORTED_MODULE_4__/* .fetchPracticeById */ .p2)(_constants_practiceIds__WEBPACK_IMPORTED_MODULE_6__/* .PracticeId.CARBON */ .I.CARBON);
    return {
        privacyNotice
    };
};
/* harmony default export */ __webpack_exports__["default"] = (Privacy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,6282,2122,9774,2888,179], function() { return __webpack_exec__(21524); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);